module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel box-collapse border-color-skin",
    attrs: {
      "id": "hresh1x-detail-tab3"
    }
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#tab3"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRPM4GEC2']['50']) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "tab3"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM4GEC4']['10']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.data.detail.numprdst))])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM4GEC4']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.data.detail.dtemthst))])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM4GEC4']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.setYearOutput(_vm.data.detail.dteyearst)))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM4GEC4']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.data.detail.numprden))])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM4GEC4']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.data.detail.dtemthen))])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM4GEC4']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.setYearOutput(_vm.data.detail.dteyearen)))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM4GEC4']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.data.detail.codpay) + " - " + _vm._s(_vm.data.detail.desc_codpay))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-7 clearfix"
  }, [_c('hrms-table', {
    attrs: {
      "columns": _vm.tab3Table,
      "data": _vm.data.table,
      "indexDisp": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 clearfix"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM4GEC4']['140']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amtded),
      expression: "amtded"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.amtded)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amtded = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust "
  }, [_vm._v(_vm._s(_vm.labels['HRPM4GEC4']['150']))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM4GEC4']['160']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amttotded),
      expression: "amttotded"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.amttotded)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amttotded = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust "
  }, [_vm._v(_vm._s(_vm.labels['HRPM4GEC4']['170']))])])])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-56c7bf9e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hresh1x/detailTab3.vue
// module id = 3780
// module chunks = 1